import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { values } from 'ramda';

import { parcelTableDataMapper } from '../routeDetail/model';
import {
  getSelectedParcels,
  getSelectedPreparedStops,
} from '../../store/selectors/ui/routeDetail';
import parcelDetailsColumns from '../../components/RouteManagement/ParcelDetails/parcelDetailsColumns';
import { transferParcelsColumnsConfigs } from '../../enums/columnsConfigs';

const useSelectedParcelsTableProps = (headerCellClasses, bodyCellClasses) => {
  const selectedParcels = useSelector(getSelectedParcels);
  const [stop] = useSelector(getSelectedPreparedStops);
  return useMemo(
    () => ({
      columns: parcelDetailsColumns({
        columnsConfigs: transferParcelsColumnsConfigs,
        headerCellClasses,
        bodyCellClasses,
      }),
      data: parcelTableDataMapper(values(selectedParcels), stop),
    }),
    [headerCellClasses, bodyCellClasses, stop, selectedParcels]
  );
};

export default useSelectedParcelsTableProps;
